require('./inline-components/admin/subtest-attempt');
Vue.component('admin-subtest-attempt-list', require('./components/admin/subtest-attempts/SubtestAttemptList.vue').default);
Vue.component('admin-show-subtest-attempt', require('./components/admin/subtest-attempts/ShowSubtestAttempt.vue').default);
Vue.component('admin-grade-subtest-attempt', require('./components/admin/subtest-attempts/GradeSubtestAttempt.vue').default);
Vue.component('admin-feedback-subtest-attempt', require('./components/admin/subtest-attempts/FeedbackSubtestAttempt.vue').default);
Vue.component('admin-assign-subtest-attempt', require('./components/admin/subtest-attempts/AssignSubtestAttempt.vue').default);
Vue.component('admin-cancel-subtest-attempt', require('./components/admin/subtest-attempts/CancelSubtestAttempt.vue').default);
Vue.component('admin-update-subtest-attempt-speaking-status', require('./components/admin/subtest-attempts/UpdateSubtestAttemptSpeakingStatus.vue').default);
Vue.component('admin-update-subtest-attempt-platform', require('./components/admin/subtest-attempts/UpdateSubtestAttemptPlatform.vue').default);

Vue.component('show-test-attempt', require('./components/test-attempts/ShowTestAttempt.vue').default);
Vue.component('test-attempt-list', require('./components/test-attempts/TestAttemptList.vue').default);

Vue.component('update-participant', require('./components/participants/UpdateParticipant.vue').default);

Vue.component('create-subtest-attempt', require('./components/subtest-attempts/CreateSubtestAttempt.vue').default);
Vue.component('subtest-attempt-list', require('./components/subtest-attempts/SubtestAttemptList.vue').default);
Vue.component('show-subtest-attempt', require('./components/subtest-attempts/ShowSubtestAttempt.vue').default);

require('./inline-components/admin/subtests');
Vue.component('admin-subtest-list', require('./components/admin/subtests/SubtestList.vue').default);
Vue.component('admin-show-subtest', require('./components/admin/subtests/ShowSubtest.vue').default);
Vue.component('admin-create-subtest', require('./components/admin/subtests/CreateSubtest.vue').default);
Vue.component('admin-update-subtest', require('./components/admin/subtests/UpdateSubtest.vue').default);
Vue.component('admin-delete-subtest', require('./components/admin/subtests/DeleteSubtest.vue').default);

require('./inline-components/admin/api-calls');
Vue.component('admin-api-call-list', require('./components/admin/api-calls/ApiCallList.vue').default);
Vue.component('admin-show-api-call', require('./components/admin/api-calls/ShowApiCall.vue').default);

require('./inline-components/admin/users');
Vue.component('admin-user-list', require('./components/admin/users/UserList.vue').default);
Vue.component('admin-show-user', require('./components/admin/users/ShowUser.vue').default);
Vue.component('admin-create-user', require('./components/admin/users/CreateUser.vue').default);
Vue.component('admin-update-user', require('./components/admin/users/UpdateUser.vue').default);
Vue.component('admin-delete-user', require('./components/admin/users/DeleteUser.vue').default);

require('./inline-components/admin/settings');
Vue.component('admin-update-settings-availability', require('./components/admin/settings/UpdateSettingsAvailability.vue').default);
Vue.component('admin-update-settings-dates', require('./components/admin/settings/UpdateSettingsDates.vue').default);

Vue.component('create-invoice', require('./components/invoices/CreateInvoice.vue').default);
Vue.component('update-invoice', require('./components/invoices/UpdateInvoice.vue').default);

Vue.component('create-payment', require('./components/payments/CreatePayment.vue').default);

Vue.component('calendar', require('./components/Calendar.vue').default);
Vue.component('subtest', require('./components/Subtest.vue').default);
Vue.component('icons', require('./components/Icons.vue').default);
Vue.component('number-icon', require('./components/NumberIcon.vue').default);
Vue.component('stripe', require('./components/Stripe.vue').default);

require('./inline-components/admin/coupons');
Vue.component('admin-coupon-list', require('./components/admin/coupons/CouponList.vue').default);
Vue.component('admin-show-coupon', require('./components/admin/coupons/ShowCoupon.vue').default);
Vue.component('admin-create-coupon', require('./components/admin/coupons/CreateCoupon.vue').default);
Vue.component('admin-update-coupon', require('./components/admin/coupons/UpdateCoupon.vue').default);
Vue.component('admin-delete-coupon', require('./components/admin/coupons/DeleteCoupon.vue').default);